"use client";

import React, { useEffect, useState } from "react";
import { PagePayoutSchema } from "@/sanity/pages/PagePayoutTemplate";

import { cn } from "@/lib/utils";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTAButton } from "@/shadcn/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  type CarouselApi,
} from "@/shadcn/ui/carousel";

import laurels from "@/public/payout/laurels.svg";
import ipad from "@/public/global/ipad.png";
import { PageAssetsSchema } from "@/sanity/pages/PageAssetsTemplate";

export default function IntroSection({
  data,
  className,
}: {
  data: PageAssetsSchema;
  className?: string;
}) {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const isBrazil = data?.settings?.slug?.current?.endsWith("/br");

  useEffect(() => {
    if (!api) return;

    setCurrent(api.selectedScrollSnap());

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);

  return (
    <section className={cn("relative overflow-clip", className)}>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[38.25rem] sm:w-[55rem] lg:w-[min(180rem,80%)] h-full flex justify-between opacity-50 lg:opacity-100">
        {Array.from({ length: 7 }).map((_, index) => (
          <div
            key={index}
            className={cn(
              "h-full border-l border-l-[#E5E5E5]",
              "hidden lg:block",
            )}
          />
        ))}
      </div>

      <div className="container flex flex-col items-center py-[3rem] lg:py-[8rem] relative">
        {data?.introItems && (
          <div className="bg-white w-[min(180rem,calc(100%-4rem))] lg:border lg:border-[#E5E5E5] px-[2rem] lg:px-[7rem] py-[4rem] lg:py-[5rem] flex flex-col lg:flex-row items-center lg:justify-between gap-[5rem]">
            {data.introItems.map((item, index) => (
              <div key={index} className="flex items-center gap-[1.75rem]">
                <Image
                  className="!w-[4.125rem] flex-shrink-0"
                  src={laurels}
                  alt="laurels"
                />

                <div className="flex flex-col items-center gap-[.375rem]">
                  <p className="mb-0 text-[#103037] font-semibold font-instrument-sans text-[3.25rem] leading-none">
                    {item?.number?.numberPrefix && (
                      <span>{item.number.numberPrefix}</span>
                    )}
                    {item?.number?.number && <span>{item.number.number}</span>}
                    {item?.number?.numberSuffix && (
                      <span>{item.number.numberSuffix}</span>
                    )}
                  </p>
                  <p className="mb-0 text-[#414141] text-[2rem] leading-none">
                    {item?.text}
                  </p>
                </div>

                <Image
                  className="!w-[4.125rem] flex-shrink-0 -scale-x-100"
                  src={laurels}
                  alt="laurels"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
